module.exports = __webpack_public_path__ + "img/tem.a7a19176.svg";